import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'קולקציות',
    href: '#collections'
  }, {
    name: 'אודות',
    href: '#philosophy'
  }, {
    name: 'סדנה',
    href: '#craft'
  }, {
    name: 'יצירת קשר',
    href: '#appointment'
  }];
  return <>
      <motion.nav initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 1.5,
      ease: [0.16, 1, 0.3, 1]
    }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${isScrolled ? 'bg-ivory/90 backdrop-blur-md py-4' : 'bg-transparent py-8'}`} data-id="element-97">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-98">
          {/* Right side links (RTL) */}
          <div className="hidden md:flex items-center gap-12 w-1/3" data-id="element-99">
            {navLinks.slice(0, 2).map(link => <a key={link.name} href={link.href} className="label-tiny text-charcoal/70 hover:text-charcoal transition-colors duration-500" data-id="element-100">
                {link.name}
              </a>)}
          </div>

          {/* Center Logo */}
          <div className="flex flex-col items-center justify-center w-1/3" data-id="element-101">
            <a href="#" className="flex flex-col items-center group" data-id="element-102">
              <span className="serif-latin text-3xl md:text-4xl tracking-[0.15em] text-charcoal group-hover:text-gold transition-colors duration-700" data-id="element-103">
                AURÉ
              </span>
              <span className="serif text-sm tracking-widest text-charcoal/60 mt-1" data-id="element-104">
                אוֹרֶה
              </span>
            </a>
          </div>

          {/* Left side links & CTA */}
          <div className="hidden md:flex items-center justify-end gap-12 w-1/3" data-id="element-105">
            {navLinks.slice(2, 4).map(link => <a key={link.name} href={link.href} className="label-tiny text-charcoal/70 hover:text-charcoal transition-colors duration-500" data-id="element-106">
                {link.name}
              </a>)}
            <a href="#appointment" className="label-tiny text-charcoal border-b border-charcoal/20 pb-1 hover:border-gold hover:text-gold transition-colors duration-500" data-id="element-107">
              קביעת פגישה
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden text-charcoal p-2" onClick={() => setMobileMenuOpen(true)} data-id="element-108">
            <Menu size={24} strokeWidth={1} data-id="element-109" />
          </button>
        </div>
      </motion.nav>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-110">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.7,
        ease: [0.16, 1, 0.3, 1]
      }} className="fixed inset-0 z-[60] bg-ivory flex flex-col items-center justify-center" data-id="element-111">
            <button className="absolute top-8 left-6 text-charcoal p-2" onClick={() => setMobileMenuOpen(false)} data-id="element-112">
              <X size={24} strokeWidth={1} data-id="element-113" />
            </button>

            <div className="flex flex-col items-center gap-10" data-id="element-114">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="serif text-3xl text-charcoal hover:text-gold transition-colors duration-500" data-id="element-115">
                  {link.name}
                </a>)}
              <a href="#appointment" onClick={() => setMobileMenuOpen(false)} className="label-tiny mt-8 text-charcoal border-b border-charcoal/20 pb-1 hover:border-gold hover:text-gold transition-colors duration-500" data-id="element-116">
                קביעת פגישה
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}